module.exports = __webpack_public_path__ + "static/media/bisiness-card.484eb29f.svg";